







































import { Validator } from 'vee-validate'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Inject, Prop } from 'vue-property-decorator'

import { AddressFieldsEnabledState } from '@spa/components/pages/mypage/edit/contact/interaction'
import { PluginMixin } from '@spa/mixins/plugin'
import AddressForm from './AddressForm.vue'
import { AddressFormState } from './addressFormState'
import NameForm from './NameForm.vue'
import { NameFormState } from './nameFormState'
import PhoneticNameForm from './PhoneticNameForm.vue'
import { PhoneticNameFormState } from './phoneticNameFormState'
import TelForm from './TelForm.vue'

@Component({
  components: {
    AddressForm,
    NameForm,
    PhoneticNameForm,
    TelForm,
  },
})
export default class ReorderUserProfile extends Mixins<PluginMixin>(PluginMixin) {
  @Inject()
  $validator: Validator

  @Prop({ default: '' })
  tel: string

  @Prop({ default: '' })
  firstName

  @Prop({ default: '' })
  lastName

  @Prop({ default: '' })
  phoneticFirstName

  @Prop({ default: '' })
  phoneticLastName

  @Prop({ default: '' })
  zipcode: string

  @Prop({ default: '' })
  prefectureCode: string

  @Prop({ default: '' })
  city: string

  @Prop({ default: '' })
  town: string

  @Prop({ required: true })
  addressFieldsEnabledState: AddressFieldsEnabledState

  @Prop({ required: true })
  handleTelFormUpdated: (val: string) => void

  @Prop({ required: true })
  handleNameFormUpdated: (val: NameFormState) => void

  @Prop({ required: true })
  handlePhoneticNameFormUpdated: (val: PhoneticNameFormState) => void

  @Prop({ required: true })
  handleAddressFormUpdated: (val: AddressFormState) => void
}
